import { Logger } from '@/components/Logger'
import { type PlexSubscription, plexWebSocketClient } from '@/services/api/plex/PlexWebSocketClient'

type RealtimeOptions = {
  onMessage?: (data: any) => void
  onOpen?: () => void
  onError?: (error: Event) => void
  onClose?: (event: CloseEvent) => void
}

type RealtimePlexSubscription = Omit<
  PlexSubscription,
  'onNotification' | 'onSubscribed' | 'onDisconnected' | 'onError'
> & {
  mapNotification?: (data: unknown) => unknown
}

// Expose the existing realtime callback shape while treating subscription acknowledgement
// as readiness; an open shared socket alone does not mean this feed is subscribed.
export const subscribeRealtime = (
  realtimeOptions: RealtimeOptions,
  plex: RealtimePlexSubscription,
) => {
  return plexWebSocketClient.subscribe({
    ...plex,
    onNotification: (data) => {
      realtimeOptions.onMessage?.(plex.mapNotification ? plex.mapNotification(data) : data)
    },
    onSubscribed: realtimeOptions.onOpen,
    onDisconnected: realtimeOptions.onClose,
    onError: (error) => {
      Logger.error(`wsplex: ${plex.key}`, error)
      realtimeOptions.onError?.(error as unknown as Event)
    },
  })
}
